import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { PACKAGE_NAME, TEAM } from '../../common/constants';
import type {
	EditPriorityResponse,
	CreateAndEditPriorityRequestBody,
	RefinedFetchError,
} from '../../common/types';
import { DUPLICATE_NAME_ERROR, getIsDuplicateNameError } from '../duplicate-priority-name-error';
import { refineFetchError } from '../utils';

export const editPriority = async (
	id: string,
	requestBody: CreateAndEditPriorityRequestBody,
): Promise<EditPriorityResponse> => {
	try {
		return await performPutRequest(`/rest/api/3/priority/${id}`, {
			body: JSON.stringify(requestBody),
		});
	} catch (error) {
		const fetchError: RefinedFetchError | undefined = refineFetchError(error);
		fireErrorAnalytics({
			error: fetchError
				? new Error(
						`edit priority failed with status code ${fetchError.statusCode}, traceId ${fetchError.traceId} and message ${fetchError.message}`,
					)
				: new Error(`edit priority failed with error ${error}`),
			meta: {
				id: 'editPriority',
				packageName: PACKAGE_NAME,
				teamName: TEAM,
			},
			sendToPrivacyUnsafeSplunk: true,
		});

		if (error instanceof Error && getIsDuplicateNameError(error.message)) {
			throw new Error(DUPLICATE_NAME_ERROR);
		}

		throw error;
	}
};
